"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var repeater_1 = require("./repeater");
var repeater_section_utils_1 = require("./repeater/repeater-section-utils");
var repeater_addons_1 = require("./repeater/repeater-addons");
var EpsilonSectionRepeater = /** @class */ (function (_super) {
    __extends(EpsilonSectionRepeater, _super);
    /**
     * Object constructor
     * @param control
     */
    function EpsilonSectionRepeater(control) {
        var _this = _super.call(this, control) || this;
        /**
         * We need to move this element to the bottom of the page so it renders properly
         */
        _this._moveElements();
        /**
         * Events that fires from the main page
         * so we can focus our panel and repeatable section
         */
        _this._handleNavigation();
        /**
         * Initiate Search on sections
         */
        _this._initSearch();
        /**
         * Handle integration tab functionality
         */
        _this._handleIntegrations();
        return _this;
    }
    /**
     * Repeater container
     * @returns {any}
     */
    EpsilonSectionRepeater.prototype.getRepeaterContainer = function () {
        return this.context.find('.repeater-sections');
    };
    /**
     * Load utilities
     * @public
     */
    EpsilonSectionRepeater.prototype.loadUtils = function () {
        return new repeater_section_utils_1.EpsilonRepeaterSectionUtils(this);
    };
    /**
     * Create existing rows
     * @public
     */
    EpsilonSectionRepeater.prototype.createExistingRows = function () {
        var control = this;
        if (this.control.params.value.length) {
            for (var i = 0; i < this.control.params.value.length; i++) {
                var row = void 0, addons = void 0;
                row = control.utils.add(control.control.params.value[i]);
                if (false !== row) {
                    addons = new repeater_addons_1.EpsilonRepeaterAddons(control, row);
                    addons.initPlugins();
                }
            }
        }
    };
    /**
     * Handle events
     * @public
     */
    EpsilonSectionRepeater.prototype.handleEvents = function () {
        var self = this;
        self.utils.addButton();
        /**
         * Addition of sections
         */
        jQuery('#sections-left-' + this.control.params.id).on('click', '.epsilon-section [data-action="add"]', function (e) {
            e.preventDefault();
            if (!self.limit || self.currentIndex < self.limit) {
                var row = void 0, addons = void 0;
                row = self.utils.add({ type: jQuery(this).parent().attr('data-id') });
                addons = new repeater_addons_1.EpsilonRepeaterAddons(self, row);
                addons.initPlugins();
                jQuery('body').removeClass('adding-section');
                jQuery('#sections-left-' + self.control.params.id).find('.available-sections').removeClass('opened');
                if (self.control.params['selective_refresh']) {
                    wp.customize.previewer.refresh();
                }
            }
            else {
                jQuery(self.control.selector + ' .limit').addClass('highlight');
            }
        });
        /**
         * Section description
         */
        jQuery('#sections-left-' + this.control.params.id).on('click', '.epsilon-section [data-action="info"]', function (e) {
            e.preventDefault();
            jQuery(this).parent().find('.epsilon-section-image-description').toggleClass('active');
            jQuery(this).parent().find('.epsilon-section-description').toggleClass('active');
        });
        /**
         * Section remove
         */
        this.context.on('click', '.repeater-row-remove', function (e) {
            self.handleRowDecrementor();
            if (!self.limit || self.currentIndex < self.limit) {
                jQuery(self.control.selector + ' .limit').removeClass('highlight');
            }
        });
    };
    /**
     *
     * @private
     */
    EpsilonSectionRepeater.prototype._handleNavigation = function () {
        var self = this;
        /**
         * Event that fires from the main page
         * so we can focus our panel and repeatable section
         */
        wp.customize.previewer.bind('epsilon-section-edit', function (data) {
            /**
             * In case the section does not exist, we can terminate
             */
            if ('undefined' === typeof (wp.customize.section(data.customizerSection))) {
                return;
            }
            /**
             * Iterate over the controls, minimize everything
             */
            _.each(self.rows, function (sect, index) {
                if (!sect.container.hasClass('minimized') && sect.index != data.section) {
                    self.utils.toggleMinimize(sect);
                }
            });
            wp.customize.section(data.customizerSection).focus();
            /**
             * Focus repeatable section
             */
            if (!_.isUndefined(self.rows[data.section]) && self.rows[data.section].container.hasClass('minimized')) {
                self.utils.toggleMinimize(self.rows[data.section]);
            }
            if (typeof data.sectionTab === 'string') {
                self.rows[data.section].container.find('nav').find('a[data-item=' + data.sectionTab + ']').click();
            }
        });
    };
    /**
     * Search functionality in the sections library
     *
     * @param selector
     */
    EpsilonSectionRepeater.prototype._initSearch = function () {
        var self = this;
        var selector = jQuery('#sections-left-' + self.control.params.id), input = selector.find('.sections-search-input'), val, collection, id;
        input.on('keyup change', _.debounce(function (e) {
            val = input.val();
            if ('undefined' !== typeof val) {
                val = val.toLowerCase();
            }
            collection = selector.find('.epsilon-section');
            jQuery.each(collection, function () {
                id = jQuery(this).attr('data-id');
                if ('undefined' !== typeof id) {
                    id = id.toLowerCase();
                }
                jQuery(this)[id.indexOf(val) !== -1 ? 'show' : 'hide']();
            });
        }, 1000));
    };
    /**
     * Handles the "tab" navigation in the available section list
     * @private
     */
    EpsilonSectionRepeater.prototype._handleIntegrations = function () {
        if (!this.control.params.integrations) {
            return;
        }
        jQuery('#sections-left-' + this.control.params.id).on('click', '.available-sections-tab-toggler', function (e) {
            var tab = jQuery(this).attr('data-tab');
            jQuery(this).siblings().removeClass('active');
            jQuery(this).addClass('active');
            e.preventDefault();
            if ('undefined' !== typeof tab) {
                jQuery('[data-tab-id="' + tab + '"]').siblings('div').removeClass('active').slideUp();
                jQuery('[data-tab-id="' + tab + '"]').slideDown().addClass('active');
            }
        });
    };
    /**
     * Move items "phisically"
     * @private
     */
    EpsilonSectionRepeater.prototype._moveElements = function () {
        jQuery('#sections-left-' + this.control.params.id).appendTo(jQuery('.wp-full-overlay'));
    };
    return EpsilonSectionRepeater;
}(repeater_1.EpsilonFieldRepeater));
exports.EpsilonSectionRepeater = EpsilonSectionRepeater;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/section-repeater.ts
// module id = 46
// module chunks = 0